module.exports = __webpack_public_path__ + "static/media/nonord c 1.f37e3a74.mp3";